import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ChangeStatusPage} from './change-status';
import {TranslateModule} from "@ngx-translate/core";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    ChangeStatusPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(ChangeStatusPage),
    TranslateModule.forChild(),
    DirectivesModule,
    PipesModule
  ]
})
export class ChangeStatusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/change-status/change-status.module.ts